import Vue from 'vue'
import Vuex from 'vuex'
import * as actions from './actions'
import * as mutations from './mutations'
import * as Cookies from 'js-cookie'
import createPersistedStore from 'vuex-persistedstate'
import _ from 'lodash'

Vue.use(Vuex)

export default new Vuex.Store({
    plugins: [
        createPersistedStore({
          getState: (key) => Cookies.getJSON(key),
          setState: (key, state) => Cookies.set(key, state, {
            expires: parseInt(process.env.VUE_APP_COOKIES_EXPIRE_TIME),
            secure: (process.env.VUE_APP_COOKIES_SECURE === 'true')
          })
        })
    ],
    state: {
        token: null,
        refreshToken: null,
        user: null,
        signature: null,
        api: process.env.VUE_APP_API_URL,
        api_files: process.env.VUE_APP_API_URL + 'files/'
    },
    actions,
    getters: {
        getLocale: state => {
            return ((state.user && state.user.locale) ? state.user.locale : process.env.VUE_APP_LOCALE)
        },
        getRoles: state => {
            return state.user ? [state.user.role] : []
        },
        getPermissions: state => {
            return state.user ? state.user.permissions : []
        }
    },
    mutations,
    modules: {}
})